import {
  Dialog,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import html2canvas from "html2canvas";
import React, { useEffect, useRef, useState } from "react";
import succesImage from "../../image/succes.jpg";
import CancelIcon from "@mui/icons-material/Cancel";
import { Wheel } from "react-custom-roulette";
import { useTheme } from "@mui/material/styles";
import axios from "axios"; 
import { useSelector } from "react-redux";
import { api_base } from "../../env";
import OrderImage from "../commandImage/OrderImage";
import { ImportButton } from "../UploadFiles";
import TitreTypography from "../Typography/TitreTypography";
import SousTitreTypography from "../Typography/SousTitreTypography";

export default function SuccessWithRouletteDialog({
  open,
  onClose,
  code,
  clientType,
  idCommande,
}) {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(null);
  const [result, setResult] = useState("");
  const [selectedReductionId, setSelectedReductionId] = useState(null);
  const { RoulleteData } = useSelector((state) => state.dataApp);
  //const RoulleteData = { displayReduction: true, reductions: [] };
  const data = [];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const hasReductions =
    Array.isArray(RoulleteData?.reductions) &&
    RoulleteData.reductions.length > 0;

  if (hasReductions) {
    RoulleteData.reductions.forEach((r, index) => {
      data.push({
        id: r.id,
        option: r.type === "percent" ? `- ${r.NomReduction} %` : r.NomReduction,
        type: r.type,
        style: {
          backgroundColor: index % 2 === 0 ? "#59cbd7" : "white",
          textColor: index % 2 === 0 ? "white" : "black",
        },
      });
    });
  }

  const handleSpinClick = () => {
    if (!hasReductions || data.length === 0) {
      console.warn("Aucune réduction disponible !");
      return;
    }

    const resultArray = [];
    const isFidele = clientType === "fidele";

    RoulleteData.reductions.forEach((item) => {
      const count = isFidele ? item.ClientFidele : item.Client;
      for (let i = 0; i < count; i++) {
        resultArray.push(item.id);
      }
    });

    if (resultArray.length === 0) {
      console.warn("Aucune option à sélectionner.");
      return;
    }

    const selectedId =
      resultArray[Math.floor(Math.random() * resultArray.length)];
    const numberSelected = data.findIndex((d) => d.id === selectedId);

    if (numberSelected === -1) {
      console.warn("ID sélectionné non trouvé dans les données.");
      return;
    }

    setPrizeNumber(numberSelected);
    setMustSpin(true);
  };

  const handleReductionSave = async (idReduction) => {
    try {
      await axios.post(`${api_base}command/reduction`, {
        idCommande,
        idReduction,
      });
      console.log("Réduction enregistrée !");
    } catch (error) {
      console.error("Erreur lors de l’enregistrement de la réduction:", error);
    }
  };

  const contentRef = useRef();
  const [imageUrl, setImageUrl] = useState(null);
  console.log("data :", data);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      scroll="body"
      PaperProps={{ style: { borderRadius: 20, margin: isMobile ? 0 : 20 } }}
      TransitionProps={{
        onEntered: () => {
          if (contentRef.current) {
            html2canvas(contentRef.current).then((canvas) => {
              const url = canvas.toDataURL("image/png");
              setImageUrl(url);
              const link = document.createElement("a");
              link.href = url;
              link.download = `commande_${code}.png`;
              link.click();
            });
          }
        },
      }}
    >
      <Card style={{ position: "relative" }}>
        <IconButton
          onClick={onClose}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "#B31312",
          }}
        >
          <CancelIcon />
        </IconButton>

        <CardContent style={{ textAlign: "center", padding: 0 }}>
          <div ref={contentRef}>
            <img
              src={succesImage}
              alt="succes"
              style={{
                width: isMobile ? 150 : 200,
                display: "block",
                margin: "0 auto",
              }}
            />

            <TitreTypography variant="h6">
              Votre code de commande est :
            </TitreTypography>

            <TitreTypography variant="h5">
              <b>{code}</b>
            </TitreTypography>

            <SousTitreTypography variant="body2" color="textSecondary">
              Votre commande a été créée avec succès
            </SousTitreTypography>
          </div>
          {hasReductions && data.length > 0 && RoulleteData.displayReduction ? (
            <>
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={data}
                onStopSpinning={() => {
                  setMustSpin(false);
                  const prize = data[prizeNumber];

                  if (!prize) {
                    console.warn("Aucun prix trouvé.");
                    return;
                  }

                  const idReduction = prize.id;
                  setSelectedReductionId(idReduction);
                  console.log("prize :", prize);

                  if (prize.type === "print") {
                    setResult(
                      `🎁 Félicitations ! Vous avez gagné : ${prize.option}`
                    );
                  } else {
                    setResult(`🎉 Ta remise est de : ${prize.option}%`);
                  }

                  handleReductionSave(idReduction);
                }}
              />

              {result ? (
                <ImportButton
                  fullwidth
                    onClick={onClose}
                  sx={{ marginTop: 10, marginBottom: 2, width: "90%" }}
                >
                  Continuer
                </ImportButton>
              ) : (
                <ImportButton
                  onClick={handleSpinClick}
                  fullwidth
                  sx={{
                    marginTop: 15,
                    marginBottom: 2,
                    width: "90%",
                  }}
                >
                  🎡 Lancer la
                </ImportButton>
              )}
            </>
          ) : (
            <ImportButton
              fullwidth
              onClick={onClose}
              sx={{ marginTop: 10, marginBottom: 2, width: "90%" }}
            >
              Continuer
            </ImportButton>
          )}
        </CardContent>
      </Card>

      <OrderImage orderCode={code} onImageReady={setImageUrl} />
    </Dialog>
  );
}
